export default function QuestionCard({
  question, index, total, selected, onSelect, showAnswer, flagged, onFlag, isExam,
}) {
  const { question: text, options, answer, explanation } = question;

  return (
    <div className="question-card">
      <div className="question-header">
        <span className="q-number">Q{index + 1} / {total}</span>
        <button className={`flag-btn ${flagged ? "flagged" : ""}`} onClick={onFlag}>
          {flagged ? "🚩 Flagged" : "⚑ Flag"}
        </button>
      </div>

      <p className="question-text">{text}</p>

      <ul className="options-list">
        {options.map((opt, i) => {
          let cls = "option";
          if (showAnswer) {
            if (i === answer) cls += " correct";
            else if (i === selected && i !== answer) cls += " incorrect";
          } else if (i === selected) {
            cls += " selected";
          }
          return (
            <li key={i}>
              <button
                className={cls}
                onClick={() => !showAnswer && onSelect(i)}
                disabled={showAnswer}
              >
                <span className="opt-letter">{String.fromCharCode(65 + i)}</span>
                <span className="opt-text">{opt}</span>
                {showAnswer && i === answer && <span className="opt-badge correct-badge">✓ Correct</span>}
                {showAnswer && i === selected && i !== answer && <span className="opt-badge incorrect-badge">✗ Your answer</span>}
              </button>
            </li>
          );
        })}
      </ul>

      {showAnswer && (
        <div className={`explanation ${selected === answer ? "correct-exp" : "incorrect-exp"}`}>
          <strong>{selected === answer ? "✓ Correct!" : "✗ Incorrect."}</strong>{" "}
          {explanation}
        </div>
      )}
    </div>
  );
}
